export enum ComplaintTypes {
    //grid
    GET_COMPLAINT_LOADING = '@@complaint/GET_COMPLAINT_LOADING',
    GET_COMPLAINT_SUCCESS = '@@complaint/GET_COMPLAINT_SUCCESS',
    GET_COMPLAINT_FAIL = '@@complaint/GET_COMPLAINT_FAIL',

    GET_MANUFACTURER_DROPDOWN_LOADING = '@@complaint/GET_MANUFACTURER_DROPDOWN_LOADING',
    GET_MANUFACTURER_DROPDOWN_SUCCESS = '@@complaint/GET_MANUFACTURER_DROPDOWN_SUCCESS',
    GET_MANUFACTURER_DROPDOWN_FAIL = '@@complaint/GET_MANUFACTURER_DROPDOWN_FAIL',

    GET_COMPLAINT_BY_ID_LOADING = '@@complaint/GET_COMPLAINT_BY_ID_LOADING',
    GET_COMPLAINT_BY_ID_SUCCESS = '@@complaint/GET_COMPLAINT_BY_ID_SUCCESS',
    GET_COMPLAINT_BY_ID_FAIL = '@@complaint/GET_COMPLAINT_BY_ID_FAIL',

    CREATE_COMPLAINT_LOADING = '@@complaint/CREATE_COMPLAINT_LOADING',
    CREATE_COMPLAINT_SUCCESS = '@@complaint/CREATE_COMPLAINT_SUCCESS',
    CREATE_COMPLAINT_FAIL = '@@complaint/CREATE_COMPLAINT_FAIL',

    DELETE_COMPLAINT_LOADING = '@@complaint/DELETE_COMPLAINT_LOADING',
    DELETE_COMPLAINT_SUCCESS = '@@complaint/DELETE_COMPLAINT_SUCCESS',
    DELETE_COMPLAINT_FAIL = '@@complaint/DELETE_COMPLAINT_FAIL',

    GET_COMPLAINT_DROPDOWN_LOADING = '@@complaint/GET_COMPLAINT_DROPDOWN_LOADING',
    GET_COMPLAINT_DROPDOWN_SUCCESS = '@@complaint/GET_COMPLAINT_DROPDOWN_SUCCESS',
    GET_COMPLAINT_DROPDOWN_FAIL = '@@complaint/GET_COMPLAINT_DROPDOWN_FAIL',
    CLEAR_COMPLAINT_DROPDOWN = '@@complaint/CLEAR_COMPLAINT_DROPDOWN',

    GET_PREFIX_DROPDOWN_LOADING = '@@complaint/GET_PREFIX_DROPDOWN_LOADING',
    GET_PREFIX_DROPDOWN_SUCCESS = '@@complaint/GET_PREFIX_DROPDOWN_SUCCESS',
    GET_PREFIX_DROPDOWN_FAIL = '@@complaint/GET_PREFIX_DROPDOWN_FAIL',

    GET_ALL_COMPLAINT_DROPDOWN_LOADING = '@@complaint/GET_ALL_COMPLAINT_DROPDOWN_LOADING',
    GET_ALL_COMPLAINT_DROPDOWN_SUCCESS = '@@complaint/GET_ALL_COMPLAINT_DROPDOWN_SUCCESS',
    GET_ALL_COMPLAINT_DROPDOWN_FAIL = '@@complaint/GET_ALL_COMPLAINT_DROPDOWN_FAIL',

    GET_COMPLAINT_FILES_LOADING = '@@complaint/GET_COMPLAINT_FILES_LOADING',
    GET_COMPLAINT_FILES_SUCCESS = '@@complaint/GET_COMPLAINT_FILES_SUCCESS',
    GET_COMPLAINT_FILES_FAIL = '@@complaint/GET_COMPLAINT_FILES_FAIL',

    DELETE_COMPLAINT_FILES_LOADING = '@@complaint/DELETE_COMPLAINT_FILES_LOADING',
    DELETE_COMPLAINT_FILES_SUCCESS = '@@complaint/DELETE_COMPLAINT_FILES_SUCCESS',
    DELETE_COMPLAINT_FILES_FAIL = '@@complaint/DELETE_COMPLAINT_FILES_FAIL',

    CLEAR_MESSAGE = '@@complaint/CLEAR_MESSAGE',
    RESET_MESSAGE = '@@complaint/RESET_MESSAGE',
}